import IonUI from '@/components/ui';

import IonForm from '@/components/IonForm.vue';
import IonSelect from '@/components/IonSelect.vue';
import Detail from '@/components/detail/detail.vue';
import DetailItem from '@/components/detail/detailItem.vue';
import GroupForm from '@/components/groupForm/groupForm.vue';
import GroupFormItem from '@/components/groupForm/groupFormItem.vue';

export default Vue => {
  Vue.use(IonUI);
  Vue.component(Detail.name, Detail);
  Vue.component(IonForm.name, IonForm);
  Vue.component(IonSelect.name, IonSelect);
  Vue.component(GroupForm.name, GroupForm);
  Vue.component(DetailItem.name, DetailItem);
  Vue.component(GroupFormItem.name, GroupFormItem);
};
